<template>
  <div class="home-container">
    <img alt="产品中心" src="@/assets/product_image1.jpg" style="width: 100%" />
    <div class="product-container">
      <div class="row-center">
        <div class="product-title">产品中心</div>
        <div class="product-title-line"></div>
      </div>

      <div style="min-height: 300px" v-loading="loading">
        <el-radio-group
          v-model="activeName"
          style="margin-bottom: 30px"
          @change="handleClick"
          class="tabs-panel"
          v-if="typeList.length > 0"
        >
          <el-radio-button v-for="(item, index) in typeList" :label="item.id" @click.native="getProductType(item.productType)"> {{
            item.productType
          }}</el-radio-button>
          <!-- <el-radio-button label="心脏安全项目"></el-radio-button>
          <el-radio-button label="心脏预防项目"></el-radio-button>
          <el-radio-button label="体医融合项目"></el-radio-button> -->
        </el-radio-group>
        <div class="product-list mt-64">
          <div
            class="product-item row-space-center row-direction"
            v-for="(item, index) in list"
            :key="index"
            @click="handleDetail(item.id)"
          >
            <div class="product-image row-space-center">
              <img :alt="'+item.productName+'"
                :src="'https://admin.miraclink.com/prod-api' + item.productCoverImg"
                style="width: 80%"
              />
            </div>
            <div class="mt-64">{{ item.productName }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { baseUrl } from '@/config/url.config.js'
import { getProductTypeList, getProductList } from '@/api/common'
export default {
  name: 'Product',
  data() {
    return {
      activeName: '心脏康复项目',
      activePType:"",
      loading: false,
      typeList: [],
      list: [
        {
          title: '心脏康复项目',
          list: [
            {
              title: 'Q-Tel Beta心脏康复管理系统',
              image: require('@/assets/product-type-image1.png'),
            },
            {
              title: '智能物联网M-100P 功率踏车',
              image: require('@/assets/product-type-image2.png'),
            },
            {
              title: '智能上肢训练器Miraclink-50P',
              image: require('@/assets/product-type-image3.png'),
            },
            {
              title: '智能物联网M-200P 功率踏车',
              image: require('@/assets/product-type-image4.png'),
            },
            {
              title: '运动平板TMX-425',
              image: require('@/assets/product-type-image5.png'),
            },
            {
              title: '气蠹式体外反博装置SECP-II',
              image: require('@/assets/product-type-image6.png'),
            },
          ],
        },
        {
          title: '心脏安全项目',
          list: [
            {
              title: '心电图机 ELI280 ELI380',
              image: require('@/assets/product-type2-image1.png'),
            },
            {
              title: '动态心电记录仪H-12+',
              image: require('@/assets/product-type2-image2.png'),
            },
            {
              title: '动态血压记录仪 ABPM-05',
              image: require('@/assets/product-type2-image3.png'),
            },
            {
              title: '无创心输出量测量系统 Enduro/ICG1000',
              image: require('@/assets/product-type2-image4.png'),
            },
            {
              title: '中央监护系统 MB800-hub',
              image: require('@/assets/product-type2-image5.png'),
            },
            {
              title: '腕式血氧仪 W60',
              image: require('@/assets/product-type2-image6.png'),
            },
          ],
        },
        {
          title: '心脏预防项目',
          list: [
            {
              title: '动脉硬化测量仪VS2000',
              image: require('@/assets/product-type3-image1.png'),
            },
            {
              title: '肺功能测试仪Air Smart Extra/MSA100BT',
              image: require('@/assets/product-type3-image2.png'),
            },
            {
              title: '肺评估仪Webcpt',
              image: require('@/assets/product-type3-image3.png'),
            },
          ],
        },
        {
          title: '体医融合项目',
          list: [
            {
              title: '肺活量训练仪 Air fit ',
              image: require('@/assets/product-type4-image1.png'),
            },
            {
              title: '电动压力喷雾洗鼻器 Air flow 2',
              image: require('@/assets/product-type4-image2.png'),
            },
            {
              title: '便携式超声雾化器 Air360 mini / Air  Plus  3/Air  Pro  6+',
              image: require('@/assets/product-type4-image3.png'),
            },
            {
              title: '眼部雾化器Air Spa eyes (S3/S4/S6)',
              image: require('@/assets/product-type4-image4.png'),
            },
          ],
        },
      ],

      currentIndex: 0,
      url: '',
    }
  },
  created() {
    this.url = baseUrl
    console.log(this.url)
    this.init()
  },
  methods: {
    async init() {
      this.loading = true
      await this.getType()
      await this.getList()
    },

    async getType() {
      const res = await getProductTypeList()
      if (res.code == 200) {
        this.typeList = res.data
        this.activeName = this.typeList.length > 0 ? this.typeList[0].id : ''
        this.activePType =   this.typeList.length > 0 ? this.typeList[0].productType : ''
      }
    },

    async getList() {
      const res = await getProductList({
        id: this.activeName,
      })
      if (res.code == 200) {
        this.list = res.data
        this.loading = false
      }
    },
    async handleClick() {
      this.loading = true
      await this.getList()
      this.loading = false
    },

    getProductType(type){
        console.log("getProductType",type)
      this.activePType = type;
    },
    handleDetail(id) {
      this.$router
        .push({
          path: '/productDetails/' + id
        })
        .catch((error) => {
          console.log(error)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.module.scss';
@import '@/styles/mixin.scss';

.product-container {
  padding: 48px 64px;
  box-sizing: border-box;
}

.product-title {
  font-size: 24px;
  font-weight: 600;
}

.product-title-line {
  background: #203060;
  width: 40px;
  height: 3px;
  margin-left: 12px;
}

.tabs-panel {
  margin-top: 32px;
}

.product-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  column-gap: 64px;
  row-gap: 64px;
}

.product-item {
  width: 100%;
}

:deep(.tabs-panel .el-tabs__active-bar) {
  background-color: #fff !important;
}

:deep(.el-radio-button__orig-radio:checked + .el-radio-button__inner) {
  color: #0393b6 !important;
  background-color: transparent !important;
  border-color: transparent !important;
  box-shadow: none !important;
  font-weight: 600;
}

:deep(.el-radio-button__inner) {
  font-size: 16px;
  background-color: transparent !important;
  border-color: transparent !important;
  padding: 12px 30px 12px 0 !important;
}

:deep(.el-radio-button__inner:hover) {
  color: #0393b6 !important;
}

.product-image {
  width: 100%;
  height: 30vh;
}

@media screen and (max-width: 1200px) {
  .product-list {
    grid-template-columns: repeat(3, 1fr);
  }

  .product-image {
    width: 100%;
    height: 30vh;
  }
}

@media screen and (max-width: 768px) {
  .product-container {
    padding: 24px 32px;
  }

  .product-title {
    font-size: 16px;
  }

  .product-title-line {
    width: 30px;
    height: 2px;
  }

  :deep(.el-radio-button__inner) {
    font-size: 14px;
    padding: 12px 12px 12px 0 !important;
  }

  .product-image {
    width: 100%;
    height: 20vh;
  }

  .product-list {
    grid-template-columns: repeat(2, 1fr);
    column-gap: 32px;
    row-gap: 32px;
  }
}

@media screen and (max-width: 600px) {
  :deep(.el-radio-button__inner) {
    font-size: 12px;
  }

  .product-list {
    grid-template-columns: repeat(2, 1fr);
    column-gap: 24px;
    row-gap: 24px;
  }
}
</style>
